// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/styles/" + "styles" + "." + "fe44b45d1d714150de69" + ".css";
};